export function sortChampionshipCarClassEntries(entries = []) {
  return entries
    .map((entry, index) => ({ entry, index }))
    .sort(
      (left, right) =>
        Number(left.entry?.displayOrder ?? 0) -
          Number(right.entry?.displayOrder ?? 0) ||
        left.index - right.index,
    )
    .map(({ entry }) => entry)
}

export function getOrderedChampionshipCarClasses(entries = []) {
  return sortChampionshipCarClassEntries(entries).map(
    (entry) => entry.carClass ?? entry,
  )
}
